import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { PeerOwnershipMovementsModel } from './peer-ownership-movements.model';

export class PeerOwnershipMovementsConfiguration extends ReportSectionConfigurationBase {
  typeName = 'PeerOwnershipMovementsConfiguration';
  nodataLocalizationKeyName = 'peerOwnershipMovements';
  readonly reportSection = ReportSection.PeerOwnershipMovements;
  readonly applicableReportTypes = [ReportType.OwnershipAnalyticsReport];
  readonly reportViewModelSections = [ReportViewModelSection.OwnershipAnalyticsReport_PeerOwnershipMovements];
  readonly minSize = 2;
  readonly maxSize = 4;
  readonly defaultSize = 2;
  readonly availableDataSections = [];

  get name(): string {
    if (this.appliedReportType === ReportType.OwnershipAnalyticsReport) {
      return 'peerOwnershipMovements';
    } else {
      throw new Error('Report Type not supported');
    }
  }

  get displayName(): string {
    if (this.appliedReportType === ReportType.OwnershipAnalyticsReport) {
      return 'Peer Ownership Movements';
    } else {
      throw new Error('Report Type not supported');
    }
  }
}

export interface PeerOwnershipMovementsData {
  [ReportViewModelSection.OwnershipAnalyticsReport_PeerOwnershipMovements]: PeerOwnershipMovementsModel;
}
